import { inject } from 'mobx-react';
import * as React from 'react';

import { BentoStore } from './bento-store';

import { traverseChildren } from './utils';

import { BentoPortion } from './bento-portion';

interface BentoBoxProps {
  bento?: BentoStore;
  name: string;
}

@inject('bento')
export class BentoBox extends React.Component<BentoBoxProps> {
  private contentCollection: { [key: string]: any } = {};

  public constructor(props) {
    super(props);
    this.getContent = this.getContent.bind(this);
  }

  private scanChildren() {
    const { bento } = this.props;
    if (bento) {
      traverseChildren(this, child => {
        if (child && child.type === BentoPortion) {
          if (child.props.local) {
            this.contentCollection[child.props.name] = child.props.children;
          } else {
            bento.declareContent(child.props.name, child.props.children);
          }

          return true;
        }

        return false;
      });
    }
  }

  public render() {
    const { bento, name } = this.props;

    if (!bento) {
      return this.props.children;
    }

    const { layout, hierarchy, options } = bento.getConfig(name);

    if (layout && hierarchy) {
      this.scanChildren();
      const result = layout.generate(hierarchy, this.getContent, options);

      if (result !== false) {
        return result;
      }
    }

    return this.props.children;
  }

  private getContent(name) {
    const { bento } = this.props;
    //Bento Store null checking is handled in render method, which is the only place this is called.

    //Default to checking the local collection first, then check global
    const content = this.contentCollection[name] || bento.getContent(name);

    return content;
  }
}
